<style lang="scss" scoped="">
  .el-row {
    margin-bottom: 10px;
  }

  .org-info {
    background: #fff;
    margin-bottom: 20px;
  }

  .base-pic-list {
    display: flex;
    flex-wrap: wrap;

    .base-pic-item {
      border: 1px solid #eee;
      position: relative;
      cursor: pointer;
      width: 180px;
      margin: 5px;
      padding: 10px;
      font-size: 12px;

      img {
        width: 180px;
        height: 180px;
        display: block;
        background: #ccc;

      }

    }
  }

</style>
<template>
  <div class="org-info" v-loading="loading">
    <form-show-part :pageSetsItem="pageSets[0]" :currentTab="{}">
      <template slot="title-right">
        <span class="ml-10">
          <el-tag type="danger" v-if="data.deleteFlag">停用</el-tag>
          <el-tag type="warning" v-else-if="data.orgAuditStatus === '0'">待审核</el-tag>
          <el-tag type="success" v-else-if="data.orgAuditStatus === '1'">正常</el-tag>
          <el-tag type="danger" v-else-if="data.orgAuditStatus === '2'">审核不通过</el-tag>
        </span>
      </template>
      <template slot="content">
        <div style="overflow: hidden;padding-right: 20px;padding-bottom: 10px">
          <perm label="mdm-biz-edit">
            <a href="#" class="pull-right reset-btn" @click.stop.prevent="editBaseInfo">
              <i class="el-icon-t-edit"></i>
            </a>
          </perm>
          <perm label="mdm-biz-org-autonomously-reject-audit">
            <el-button type="warning" class="pull-right" style="margin-right: 20px"
                       @click="noPassBaseInfo" size="mini"
                       v-show="data.orgAuditStatus==='0'">
              审核不通过
            </el-button>
          </perm>
          <perm label="mdm-biz-org-autonomously-audit">
            <el-button type="primary" class="pull-right" style="margin-right: 20px"
                       @click="auditBaseInfo" size="mini"
                       v-show="data.orgAuditStatus==='0'">
              审核通过
            </el-button>
          </perm>
        </div>
        <oms-row :span="5" label="审核不通过原因" v-if="data.rejectReason && data.orgAuditStatus === '2'">
         <span style="color: red"> {{data.rejectReason}}</span>
        </oms-row>
        <el-row>
          <el-col :span="12">
            <oms-row :label=" orgTitle +'分类' ">
              <span v-for="(relationType,index) in data.orgRelationTypeList">
                  {{formatRelationType(relationType)}}
                  <span v-if="(data.orgRelationTypeList.length-1)!==index">/</span>
              </span>
            </oms-row>
            <oms-row label="国家或地区（中文）"   v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">
              {{ data.countryOrRegionChinese }}</oms-row>
            <oms-row label="系统代码" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">{{ data.manufacturerCode }}</oms-row>
            <oms-row label="统一社会信用代码" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,12])">{{ data.creditCode }}</oms-row>
            <oms-row :label=" orgTitle +'名称' " v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">{{ data.name }}</oms-row>
            <oms-row :label=" orgTitle +'曾用名' "v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">{{ data.orgUsedName }}</oms-row>
            <oms-row label="营业执照单位类型" v-if="showField([1,0,3,0,5,6,7,0,9,0,0,12])">{{data.orgKind}}</oms-row>
            <oms-row label="所在地区" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ companyAddress }}</oms-row>
            <oms-row label="乡(镇/街道办事处)" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.orgTowns }}</oms-row>
            <oms-row label="村(街/路/弄等)" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.orgVillage }}</oms-row>
            <oms-row label="门牌号码" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.houseNumber }}</oms-row>
            <oms-row label="住所地址" v-if="showField([1,0,3,0,5,6,7,8,0,10,11,12])">{{ data.address }}</oms-row>
            <oms-row label="国家或地区（英文）" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.countryOrRegionEnglish }}</oms-row>
            <oms-row label="公司名称(中文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyChineseName }}</oms-row>
            <oms-row label="公司名称(英文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyEnglishName }}</oms-row>
            <oms-row label="公司地址(中文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyChineseAddress }}</oms-row>
            <oms-row label="公司地址(英文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyEnglishAddress }}</oms-row>
            <oms-row label="法定代表人 /机构负责人" v-if="showField([1,0,3,0,5,6,7,8,9,10,0,0])">{{ data.legalRepresentative }}</oms-row>
            <oms-row label="注册资本" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.registeredCapital}}</oms-row>
            <oms-row label="成立日期" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.establishDate | date}}</oms-row>
            <oms-row label="营业期限" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,12])">{{ data.businessTerm | date}}</oms-row>
            <oms-row label="营业执照经营范围" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.businessLicenseScope}}</oms-row>
            <oms-row label="登记机关" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.registrationAuthority}}</oms-row>
            <oms-row label="固定电话号码" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.fixedLineTelephone }}</oms-row>
            <oms-row label="传真号码" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.faxNumber }}</oms-row>
            <oms-row label="电子信箱" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.electronicMail }}</oms-row>
            <oms-row label="企业网址" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.companyWebsite }}</oms-row>
            <oms-row label="联系人" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.contact }}</oms-row>
            <oms-row label="联系电话" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.phone }}</oms-row>
            <oms-row label="邮政编码" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.postcode }}</oms-row>
            <oms-row label="接种单位编码" v-if="showField([0,0,0,0,0,0,0,0,0,10,0,0])">{{ data.inoculateOrgNo }}</oms-row>
            <oms-row label="创建人">{{ data.createdUser }}</oms-row>
            <oms-row label="创建单位" >{{ data.createdOrg }}</oms-row>
            <oms-row label="创建时间">{{ data.createTime | time }}</oms-row>
          </el-col>
          <el-col :span="12">

            <oms-row label="注册地址" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.registeredAddress }}</oms-row>
            <oms-row label="企业负责人" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.orgPrincipal }}</oms-row>
            <oms-row label="质量负责人" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.qualityPrincipal }}</oms-row>
            <oms-row label="许可证有效期" v-if="showField([1,0,3,0,5,6,0,0,0,0,11,0])">{{ data.licenceValidity | date}}</oms-row>
            <oms-row label="日常监督管理机构" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.supervisionOrg }}</oms-row>
            <oms-row label="投诉举报电话" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.complaintsHotline }}</oms-row>
            <oms-row label="许可证编号" v-if="showField([1,0,3,0,5,6,0,0,0,0,11,0])">{{ data.licenceCode }}</oms-row>
            <oms-row label="分类码" v-if="showField([1,0,0,0,0,0,0,0,0,0,0,0])">{{ data.classifyCode }}</oms-row>
            <oms-row label="生产地址" v-if="showField([1,0,3,0,0,0,0,0,0,0,0,0])">{{ data.productionAddress }}</oms-row>
            <oms-row label="许可证生产范围" v-if="showField([1,0,3,0,0,0,0,0,0,0,0,0])">{{ data.licenceProductionScope }}</oms-row>
            <oms-row label="经营方式" v-if="showField([0,0,0,0,5,6,0,0,0,0,0,0])">{{ data.manageMode }}</oms-row>
            <oms-row label="仓库地址" v-if="showField([0,0,0,0,5,6,0,0,9,0,0,0])">{{ data.warehouseAddress }}</oms-row>
            <oms-row label="许可证经营范围" v-if="showField([0,0,0,0,5,6,0,0,0,0,0,0])">{{ data.licenceManageScope }}</oms-row>
            <oms-row label="发证机关" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.certifyingAuthority }}</oms-row>
            <oms-row label="签发人" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.signIssuePerson }}</oms-row>
            <oms-row label="签发日期" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.signIssueDate | date}}</oms-row>
            <oms-row label="卫生机构代码" v-if="showField([0,0,0,0,0,0,0,0,0,0,11,0])">{{ data.healthAgencyCode }}</oms-row>
            <oms-row label="药品使用单位类型" v-if="showField([0,0,0,0,0,0,0,0,0,0,11,0])">
              <dict :dict-group="'ypOrgRelationType'" :dict-key="data.drugUserOrgType"></dict>
            </oms-row>
            <oms-row label="厂家备案凭证号" v-if="showField([0,0,3,0,0,6,0,0,0,0,0,0])">{{ data.factoryRecordNumber }}</oms-row>
          </el-col>
          <el-row>
            <el-col :span="12">
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-row>
        </el-row>
      </template>
    </form-show-part>
    <form-show-part :pageSetsItem="pageSets[1]" :currentTab="{}">
      <template slot="content">
        <div class="base-box">
          <div v-if="licenses.length === 0" class="empty-info">
            暂无信息
          </div>
          <div v-else>
            <div class="base-pic-list">
              <div v-for=" licence in licenses" class="base-pic-item">
                <div @click="watchPhoto(licence)">
                  <compressed-img :src="licence.photoThumb+'?image&action=resize:w_180,h_180,m_2'"/>
                  <h3>
                    <el-tooltip class="item" effect="dark" :content="licence.name" placement="top">
                      <span>{{licence.name}}</span>
                    </el-tooltip>
                  </h3>
                  <div>
                    <span>编号: {{licence.licenceNumber}}</span>
                  </div>
                  <div>
                    有效期:
                    <div> {{licence.validStartTime | date}} 至 {{licence.validEndTime |
                      date}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </form-show-part>
    <page-right :show="showRight" @right-close="resetRightBox" :css="{'width':'1100px','padding':0}">
      <base-form :formItem="data" :licenses="licenses" :orgTitle="orgTitle" :showRight="showRight"
                 @close="resetRightBox" action="edit" @change="onSubmit">
      </base-form>
    </page-right>
  </div>
</template>
<script>
  import utils from '@/tools/utils';
  import {BaseInfo} from '@/resources';
  import baseForm from './form.vue';

  export default {
    components: {baseForm},
    data() {
      return {
        pageSets: [
          {name: '基本信息', key: 0},
          {name: '单位证照', key: 1}
        ],
        data: {},
        showRight: false,
        licenses: [],
        orgTitle: '单位',
        loading: false,
        auditDto: {}
      };
    },
    computed: {
      companyAddress() {
        let province = this.data.province;
        let city = this.data.city;
        let region = this.data.region;
        return utils.formatAddress(province, city, region);
      }
    },
    mounted() {
      this.query();
    },
    methods: {
      noPassBaseInfo() {
        this.$prompt('', '审核不通过', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入审核不通过原因',
          inputValidator: val => {
            if (!val) return '请输入原因';
            return true;
          }
        }).then(({value}) => {
          BaseInfo.noPassBaseInfo(this.data.id, {status: '2', rejectReason: value}).then(res => {
            this.data.auditedStatus = '2';
            this.data.orgAuditStatus = '2';
            this.data.rejectReason = value;
            this.auditDto.baseInfoStatus = res.data.baseInfoStatus;
            this.$notify.success({
              duration: 2000,
              name: '成功',
              message: '审核完成'
            });
            if (this.type === 0) {
              this.$emit('change-audit-status');
            }
            // 如果是业务单位,审核完基础信息则状态转为激活
            if (this.type === 1) {
              this.$emit('state-change', res.data.status);
            }
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '审核失败'
            });
          });
        }).catch(() => {

        });
      },
      auditBaseInfo() {
        this.$confirm('确认审核通过"' + this.data.name + '"的基础信息、单位证照和经营范围等信息?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BaseInfo.auditBaseInfo(this.data.id, {status: '1'}).then(res => {
            this.data.auditedStatus = '1';
            this.data.orgAuditStatus = '1';
            this.auditDto.baseInfoStatus = res.data.baseInfoStatus;
            if (this.type === 0) {
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '审核"' + this.data.name + '"的基础信息、单位证照和经营范围等信息成功'
              });
              this.$emit('change-audit-status');
            } else {
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '审核"' + this.data.name + '"的基础信息成功,该业务单位已成功激活'
              });
            }
            // 如果是业务单位,审核完基础信息则状态转为激活
            if (this.type === 1) {
              this.$emit('state-change', res.data.status);
            }
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '审核"' + this.data.name + '"的基础信息、单位证照和经营范围等信息失败'
            });
          });
        }).catch(() => {

        });
      },
      showField(arr) {
        if (!this.data || !this.data.orgRelationTypeList) return false;
        return this.data.orgRelationTypeList.some(s => arr.some(a => (a + '') === s));
      },
      query() {
        this.loading = true;
        BaseInfo.queryBaseInfo(this.$store.state.user.userCompanyAddress).then(res => {
          this.loading = false;
          res.data.licenses.forEach(item => {
            if (item.photos && item.photos.length > 0) {
              item.photoThumb = item.photos[0].attachmentStoragePath;
            } else {
              item.photoThumb = '';
            }
          });
          this.data = res.data.orgDto;
          let licenses = res.data.licenses.filter(f =>
            this.$store.state.licenceTypeList.some(s => s.type === f.licenceType) && f.photos && f.photos.length);
          licenses.forEach(i => {
            let item = this.$store.state.licenceTypeList.find(f => f.type === i.licenceType);
            i.name = item.name;
          });
          this.data.selectOptions=[];
          this.licenses = licenses;
        });
      },
      resetRightBox: function () {
        this.showRight = false;
      },
      formatRelationType(val) {
        let relationType = this.$store.state.orgRelationType;
        return relationType[val - 1] && relationType[val - 1].label || val;
      },
      watchPhoto(item) {
        if (item.photos.length > 0) {
          this.$store.commit('changeAttachment', {
            currentId: item.photos[0].attachmentId,
            attachmentList: item.photos
          });
        }
      },
      editBaseInfo() {
        this.showRight = true;
      },
      onSubmit() {
        this.query();
        this.resetRightBox();
      }
    }
  };
</script>
